export default "__VITE_ASSET__BOQyLSQx__"